export default "__VITE_ASSET__Df6bbIQ8__"